import { ref } from 'vue'
import { defineStore } from 'pinia'
import useSystemData from './composables/useSystemData'
import type { UserModel } from '@trading/core'

export const useUserStore = defineStore('user', () => {
  const isAuthenticated = ref<boolean>(false)
  const user = ref<UserModel | null>(null)
  const { isActual, isLoadding } = useSystemData()

  function setIsAuthenticated(value: boolean) {
    isAuthenticated.value = value
  }

  function setUser(value: UserModel) {
    user.value = value
  }

  function reset() {
    user.value = null
    isAuthenticated.value = false
  }

  return { user, isActual, isLoadding, isAuthenticated, setIsAuthenticated, setUser, reset }
})
